import { colors } from '@globals/themes/defaultTheme'
import { spacing } from '@globals/themes/themeConstants'
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import { SxProps } from '@mui/material/styles'
import useRecognitionModal, {
  RecognitionModalViews,
} from '@tenant/recognition/RecognitionModal/useRecognitionModal'
import { T } from '@transifex/react'

const buttonStyle: SxProps = {
  minWidth: 0,
  borderRadius: spacing(2),
  p: 0,
  mx: 1,
  mb: 0.5,
  mt: '-23px !important',
}

const iconStyle: SxProps = {
  fontSize: '52px',
  backgroundColor: colors.goldPrimary,
  borderRadius: '50%',
  padding: 1,
  color: `${colors.white} !important`,
}

const RecognizeBottomNavButton = () => {
  const { openDialog } = useRecognitionModal()
  return (
    <BottomNavigationAction
      label={<T _str="Recognize" />}
      value="recognize"
      sx={buttonStyle}
      onClick={() =>
        openDialog({
          view: RecognitionModalViews.SendRecognition,
        })
      }
      icon={<StarBorderRoundedIcon sx={iconStyle} />}
    />
  )
}

export default RecognizeBottomNavButton
